let WS=function () {
  this.funcDic={};
};
let Log = function () {
  if (arguments.length > 0) {
    let s = "[Log]:";
    for (var i = 0; i < arguments.length; i++) {
      if (i < arguments.length - 1) {
        s += arguments[i] + " , ";
      } else {
        s += arguments[i];
      }
    }
    console.log(s);
  }
};
WS.prototype.AddFunc = function (fName, f) {
  this.funcDic[fName] = f;
};
WS.prototype.RemoveFunc = function (fName) {
  delete this.funcDic[fName];
};
WS.prototype.RemoveAllFunc = function () {
  this.funcDic = {};
};
WS.prototype.RunFunc = function () {
  //Log("RunFunc::",arguments)
  if (arguments.length == 0) {
    Log("RunFunc Error:arguments.length==0");
    return;
  }
  if (!this.funcDic[arguments[0]]) {
    Log("RunFunc Error:not find funcName:" + arguments[0] + " ||" + this.funcDic);
    // for (var k in this.funcDic) {
    //   Log("RunFunc keys:" + k);
    // }
    return;
  }
  let arr = [];
  if (arguments.length > 1) {
    for (let i = 1; i < arguments.length; i++) {
      arr.push(arguments[i]);
    }
  }
  this.funcDic[arguments[0]].apply(this, arr);
};
WS.prototype.Close = function () {
  this.ws.close();
  this.ws = null;
};
WS.prototype.Call = function () {
  if (this.ws == null) {
    Log("Call:webSocket is Closed!!");
    return;
  }
  Log("Call:" + arguments,arguments.length);
  if (arguments.length < 1) {
    this.RunFunc("Err", [ERR_SOCKET_CALL, "参数长度非法!"]);
  } else {
    let arr = [];
    for (let i = 0; i < arguments.length; i++) {
      arr.push(arguments[i]);
    }
    let str = JSON.stringify(arr);
    this.ws.send(str);
  }
};
WS.prototype.Open = function (serverName, remote) {
  let _this = this;
  //Log(conn);
  try {
    this.ws = new WebSocket(remote);
  }catch (e) {
    console.log("Try::",e)
  }
  this.ws.onerror=function(e){
    console.log('WebSocket连接打开失败，请检查！', e);
    _this.RunFunc("onConnectFail");
  };
  this.name = serverName;
  
  this.ws.onclose=function (e) {
    Log("onclose:" + e);
    _this.ws = null;
    _this.RunFunc("onDisConnect");
  };

  this.ws.onmessage=function(e){
    Log("onmessage:" + e.data);
    try{
      _this.RunFunc.apply(_this, JSON.parse(e.data));
    }catch (e){
      Log("onmessageError::",e)
    }
  };

  this.ws.onopen=function (e) {
    Log("onopen:" + arguments);
    _this.ws.binaryType = "arraybuffer";
    _this.RunFunc("onConnect");
  };
 

  // this.ws.onError = function (e) {
  //   Log("onerror:" + e);
  //   let arr = [];
  //   for (let i = 0; i < arguments.length; i++) {
  //     arr.push(arguments[i]);
  //   }
  //   _this.RunFunc("onErr", [arr]);
  // };
};

export default WS



// WEBPACK FOOTER //
// ./src/view/ws.js